<template>
    <div class="col-12 mb-5">
        <div class="card border-0" id="other_event">
            <div class="card-header bg-transparent p-0">
                <h1 class="card-title2">
                    {{ this.trans.get('kiosk.other-home-game') }}
                </h1>
            </div>
            <div class="card-body p-4" v-for="event2 in this.list_event" v-bind:disabled="if_current_event(event2)">
                <h3 class="card-title">
                    {{ this.get_event_start_date(event2) }} - {{ event2['name'] ?? this.trans.get('kiosk.event-name-is-missing') }}
                </h3>
                <div class="row">
                    <div class="col-4 pe-4">
                        <img v-bind:src="'/assets/kiosk/img/stores/'+this.$root.store_uid+'/'+this.$root.borne_configuration.match_img">
                    </div>
                    <div class="col-8">
                        <regular-product-component
                            v-for="product in this.products(event2)"
                            v-bind:product="product"
                            v-bind:event="event2"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {defineComponent, ref, watch} from "vue";
import RegularProduct from "../products/RegularProduct";
import {formatTimeStamp} from "../../helpers/kiosk-helpers";

export default defineComponent({
    name: "EventsList",

    components: {
        'regular-product-component': RegularProduct,
    },


    data() {
        return {
        }
    },

    methods: {
        products(event2)
        {
            return Object.values(event2.products).filter(function (products) {
                return products.flag_is_visible_in_normal_mode === true
            });
        },
        init() {
            this.event_start_date = formatTimeStamp(this.event.start_event,this.$root.locale);
        },
        if_current_event(event)
        {
            if(this.$root.current_event === null || event.idx === this.$root.current_event.idx)
            {
                return false;
            }
            return true;
        },
        get_event_start_date(event)
        {
            return formatTimeStamp(event.start_event);
        },
    },

    created() {
    },

    props: {
        list_event: Object,
    },

});
</script>

<style scoped>

</style>
